import React, { useLayoutEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import style from './SettingsList.module.scss';

const cx = classNames.bind(style);

interface Props {
  text: string | null;
}

// 긴 값은 한 줄로 줄여 행 높이를 고정하고, 넘칠 때만 펼치기 버튼을 보여 준다
const ClampText = ({ text }: Props) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useLayoutEffect(() => {
    setIsOpen(false);
    const element = ref.current;
    setIsOverflow(!!element && element.scrollWidth > element.clientWidth);
  }, [text]);

  if (!text) return <>-</>;

  return (
    <span className={cx('clamp-wrap')}>
      <span ref={ref} className={cx('clamp', isOpen && 'open')} title={isOpen ? undefined : text}>
        {text}
      </span>
      {(isOverflow || isOpen) && (
        <button type={'button'} className={cx('clamp-toggle')} onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? '접기' : '전체 보기'}
        </button>
      )}
    </span>
  );
};

export default ClampText;
